import React, { Component } from 'react';
import Config from '../Configs/criteria.json';
import Tooltip from 'react-tooltip-lite';
import '../Tooltip.css';
import './PresetBox.css';

export default class PresetBox extends Component {
    constructor(props) {
        super(props);
        this.type = "p";
        if (this.props.type === "custom") {
            this.type = "c";
            this.advanced = [];
            this.advancedLookup = [];
            this.advancedOptvalueLookup = [];
            this.advancedOptvalue2Lookup = [];
            Object.keys(Config.criteria.advanced).forEach((key) => {
                this.advanced[key] = [];
                for (let i = 0; i < Config.criteria.advanced[key].length; i++) {
                    this.advanced[key][i] = {
                        selected: false,
                        option: 0,
                        option2: 0,
                        lower: -9999999,
                        upper: 9999999,
                        enabled: true,
                        refreshSnap: true
                    };
                    this.advancedLookup["ca" + Config.criteria.advanced[key][i].id] = { type: key, pos: i };

                    if (Config.criteria.advanced[key][i].optvalue) {
                        this.advancedOptvalueLookup["ca" + Config.criteria.advanced[key][i].id] = [];
                        for (let j = 0; j < Config.criteria.advanced[key][i].optvalue.length; j++) {
                            this.advancedOptvalueLookup["ca" + Config.criteria.advanced[key][i].id][Config.criteria.advanced[key][i].optvalue[j]] = j;
                        }
                    }
                    if (Config.criteria.advanced[key][i].optvalue2) {
                        this.advancedOptvalue2Lookup["ca" + Config.criteria.advanced[key][i].id] = []
                        for (let j = 0; j < Config.criteria.advanced[key][i].optvalue2.length; j++) {
                            this.advancedOptvalue2Lookup["ca" + Config.criteria.advanced[key][i].id][Config.criteria.advanced[key][i].optvalue2[j]] = j;
                        }
                    }
                }
            });

            this.translateAdvCritiria();
        }
    }
    handleLoadPreset = () => {
        if (this.props.type === "custom") {
            this.props.onLoadCustom();
        } else {
            this.props.onLoadPreset();
        }
    }
    translateAdvCritiria = () => {
        let criteria = this.props.data.criteria;

        //initialization
        Object.keys(Config.criteria.advanced).forEach((key) => {
            for (let i = 0; i < Config.criteria.advanced[key].length; i++) {
                this.advanced[key][i] = {
                    selected: false,
                    option: 0,
                    option2: 0,
                    lower: -9999999,
                    upper: 9999999,
                    enabled: true,
                    refreshSnap: true
                };
            }
        });

        let cary = criteria.split(",");
        for (let i = 0; i < cary.length; i++) {
            let copt = cary[i].substr(0, 3);
            let ccontent = cary[i].substr(3);

            if (copt.substr(0, 1) === "v") {
                let val = ccontent.split("|");

                let key = this.advancedLookup["ca" + val[0]].type;
                let pos = this.advancedLookup["ca" + val[0]].pos;
                let type = Config.criteria.advanced[key][pos].type;

                let advanced = {
                    selected: true,
                    option: 0,
                    option2: 0,
                    lower: -9999999,
                    upper: 9999999,
                    enabled: true,
                    refreshSnap: true
                }

                advanced.enabled = (val[4] === "1");
                if (type === 1) {
                    advanced.lower = val[2];
                    advanced.upper = val[3];
                } else if (type === 2 || type === 3) {
                    for (let i = 0; i < Config.criteria.advanced[key][pos].optvalue.length; i++) {
                        if (Config.criteria.advanced[key][pos].optvalue[i] === val[1]) {
                            advanced.option = i;
                            break;
                        }
                    }
                    advanced.lower = val[2];
                    advanced.upper = val[3];
                } else if (type === 5) {
                    let tmpval = val[1].split("*");
                    for (let i = 0; i < Config.criteria.advanced[key][pos].optvalue2.length; i++) {
                        if (Config.criteria.advanced[key][pos].optvalue2[i] === tmpval[0]) {
                            advanced.option2 = i;
                            break;
                        }
                    }
                    for (let i = 0; i < Config.criteria.advanced[key][pos].optvalue.length; i++) {
                        if (Config.criteria.advanced[key][pos].optvalue[i] === tmpval[1]) {
                            advanced.option = i;
                            break;
                        }
                    }
                    advanced.lower = val[2];
                    advanced.upper = val[3];
                } else if (type === 4) {
                    for (let i = 0; i < Config.criteria.advanced[key][pos].optvalue.length; i++) {
                        if (Config.criteria.advanced[key][pos].optvalue[i] === val[2]) {
                            advanced.option = i;
                            break;
                        }
                    }
                    for (let i = 0; i < Config.criteria.advanced[key][pos].optvalue2.length; i++) {
                        if (Config.criteria.advanced[key][pos].optvalue2[i] === val[3]) {
                            advanced.option2 = i;
                            break;
                        }
                    }
                } else if (type === 6) {
                    for (let i = 0; i < Config.criteria.advanced[key][pos].optvalue.length; i++) {
                        if (Config.criteria.advanced[key][pos].optvalue[i] === val[2]) {
                            advanced.option = i;
                            break;
                        }
                    }
                }
                this.advanced[key][pos] = advanced;
            }
        }
    }
    generateAdvCriteriaString = (isAll) => {
        let output = [];
        let count = 0;
        let tmpTxt = this.props.data2.criteria;
        String.prototype.splice = function (idx, rem, str) {
            return this.slice(0, idx) + str + this.slice(idx + Math.abs(rem));
        };
        if (isAll) {
            for (let i = 0; i < tmpTxt.length; i++) {
                if ((i + 1) % 16 === 0) {
                    tmpTxt = tmpTxt.splice(i, 0, "\n");
                }
            }
        }
        output.push(<div>{tmpTxt}</div>);
        return output;
    }

    generateDescription = (isAll) => {
        let output = [];
        let count = 0;
        let tmpTxt = this.props.description;
        String.prototype.splice = function (idx, rem, str) {
            return this.slice(0, idx) + str + this.slice(idx + Math.abs(rem));
        };
        if (isAll) {
            for (let i = 0; i < tmpTxt.length; i++) {
                if ((i + 1) % 16 === 0) {
                    tmpTxt = tmpTxt.splice(i, 0, "\n");
                }
            }
        }
        output.push(<div>{tmpTxt}</div>);
        return output;
    }

    componentDidUpdate() {
        if (this.props.type === "custom") {
            this.translateAdvCritiria();
        }
        // console.log(this.props.presetSelected+"||"+("p"+this.props.id));

    }
    clearAll=()=>{
        this.props.clearAll("preset");
    }
    render() {
        return (
            <div className={this.props.presetSelected === (this.type + this.props.id) ? "PresetBoxSelected" : "PresetBox"} onClick={this.props.empty ? this.clearAll : this.handleLoadPreset}>
                <div className="id">{this.props.id}</div>
                {!this.props.empty &&
                    <React.Fragment>
                        <div className={this.props.type === "custom" ? "name custom" : "name"}>{this.props.name}</div>
                        {(this.props.type === "custom" && this.props.data2.criteria) &&
                            <Tooltip direction={this.props.id === "04" ? "left-start" : "right-start"} arrow={false} content={this.generateAdvCriteriaString(true)}>
                                <div className="criteriadesc">
                                    {this.generateAdvCriteriaString(false)}
                                </div>
                            </Tooltip>
                        }
                        {(this.props.type !== "custom" && this.props.description) &&
                            <Tooltip direction={this.props.id === "04" ? "left-start" : "right-start"} arrow={false} content={this.generateDescription(true)}>
                                <div className="criteriadesc">
                                    {this.generateDescription(false)}
                                </div>
                                <div className="countTooltip">合計{this.props.count}件</div>
                            </Tooltip>
                        }
                        {(this.props.type !== "custom" && !this.props.description) &&
                            <React.Fragment>
                                <div className="desc">{this.props.description}</div>
                                <div className="count">合計{this.props.count}件</div>
                            </React.Fragment>
                        }
                        <div className="search">これで検索 ></div>
                    </React.Fragment>
                }
                {this.props.empty &&
                    <div className="empty">検索条件を保存する<br />ことができます。</div>
                }
            </div>
        )
    }
}